import almaPalermo from '@/assets/demo/projects/alma-palermo.jpg'
import bravaTigre from '@/assets/demo/projects/brava-tigre.jpg'
import nexoCordoba from '@/assets/demo/projects/nexo-cordoba.jpg'

export const demoProjects = [
  {
    id: 'alma-palermo',
    backendId: 1001,
    category: 'Rentas',
    title: 'Alma Palermo',
    location: 'Palermo, Buenos Aires',
    image: almaPalermo,
    imageFallback: almaPalermo,
    target: '$ 480 M',
    funded: 0,
    raised: '$ 0',
    investors: 0,
    return: '9,8%',
    term: '36 meses',
    minimum: '$ 100.000',
    description: 'Un edificio de renta temporaria en el corazón de Palermo, pensado para una nueva forma de habitar la ciudad.',
    status: 'Oportunidad abierta',
    tone: 'sage'
  },
  {
    id: 'brava-tigre',
    backendId: 1002,
    category: 'Plusvalía',
    title: 'Brava Tigre',
    location: 'Tigre, Buenos Aires',
    image: bravaTigre,
    imageFallback: bravaTigre,
    target: '$ 620 M',
    funded: 0,
    raised: '$ 0',
    investors: 0,
    return: '17,4%',
    term: '24 meses',
    minimum: '$ 100.000',
    description: 'Casas contemporáneas junto al río, con una estrategia de desarrollo y comercialización de etapa temprana.',
    status: 'Oportunidad abierta',
    tone: 'sand'
  },
  {
    id: 'nexo-cordoba',
    backendId: 1003,
    category: 'Deuda con garantía',
    title: 'Nexo Córdoba',
    location: 'Nueva Córdoba, Córdoba',
    image: nexoCordoba,
    imageFallback: nexoCordoba,
    target: '$ 390 M',
    funded: 0,
    raised: '$ 0',
    investors: 0,
    return: '14,2%',
    term: '18 meses',
    minimum: '$ 100.000',
    description: 'Financiación puente para un desarrollo residencial con preventa avanzada y garantía sobre el activo.',
    status: 'Últimos cupos',
    tone: 'clay'
  }
]

export const demoStats = [
  { value: '12', label: 'proyectos publicados' },
  { value: '$ 1.240 M', label: 'capital movilizado' },
  { value: '1.850+', label: 'inversores registrados' },
  { value: '100%', label: 'proyectos con seguimiento' }
]

export function mergeLiveProject (base, live) {
  if (!live) return { ...base }
  const campaign = live.fundingCampaignDTO
  const funded = campaign && campaign.creditsAmount
    ? Math.round(campaign.creditsFunded * 100 / campaign.creditsAmount)
    : Math.round(live.fundingPercentage || 0)
  const period = Number(live.profitsBeginTimePeriod)
  const quantity = Number(live.profitsBeginQuantity)
  const months = period === 365 ? quantity * 12 : period === 30 ? quantity : period === 7 ? Math.round(quantity / 4) : Math.round(quantity / 30)
  return {
    ...base,
    title: live.name || base.title,
    description: live.description || base.description,
    return: live.estimatedReturn !== undefined ? `${(Number(live.estimatedReturn) * 100).toLocaleString('es-AR', { maximumFractionDigits: 1 })}%` : base.return,
    term: months > 0 ? `${months} meses` : base.term,
    funded,
    image: live.portraitId ? `${process.env.VUE_APP_CF_API_URL}/api/projects/images/${live.portraitId}?v=demo-project-images-2` : base.image,
    imageFallback: base.imageFallback || base.image,
    status: campaign && campaign.creditsAmount <= campaign.creditsFunded ? 'Campaña completa' : base.status
  }
}
